import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { connect } from 'react-redux';
import dropin from 'braintree-web-drop-in';
import BlockUi from 'react-block-ui';
import { firebase } from '../../../firebase';
import {
  getBraintreeClientToken,
  subscribe,
  activatePaypalUser,
  getPlans
} from '../../../redux/actions/user-actions';
import { Button, FormGroup, FormControl } from 'react-bootstrap';
import swal from 'sweetalert2';
import { default as config } from '../../../constants/constants';
import 'react-block-ui/style.css';
import logo from '../../../images/inflo_logo.png';

require('sweetalert2/dist/sweetalert2.css');

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value
});

const Overlay = (props) => {
  const renderTooltip = <Tooltip id="  ">{props.text}</Tooltip>;

  return (
    <OverlayTrigger placement="top" overlay={renderTooltip}>
      {props.children}
    </OverlayTrigger>
  );
};

class PaypalPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropinInstance: null,
      error: null,
      loading: false,
      name: null,
      surname: null,
      phone: null,
      email: null,
      touched: {
        name: false,
        surname: false,
        email: false,
        phone: false
      },
      isShowForm: false,
      infoMessage: '',
      typePlan: null
    };
  }

  handleBlur = (field) => (evt) => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    });
  };

  componentDidMount() {
    setTimeout(() => {
    if (firebase.auth.currentUser !== null) {
      firebase.auth.currentUser.getIdToken().then((token) => {
        this.props.dispatch(getBraintreeClientToken(token));
        this.props.dispatch(getPlans(token));
      });
    }
  }, 500 );
  }

  componentWillUnmount() {
    if (this.state.dropinInstance) {
      this.state.dropinInstance.teardown(function(err) {
        if (err) {
          console.error('An error occurred during teardown:', err);
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.braintreeToken &&
      nextProps.braintreeToken !== this.props.braintreeToken
    ) {
      let $this = this;

      dropin.create(
        {
          authorization: nextProps.braintreeToken,
          container: '.dropin-container',
          paypal: { flow: 'vault' }
        },
        function(createErr, dinInstance) {
          $this.setState({ dropinInstance: dinInstance });
        }
      );
    }
  }

  checkout = (plan, event) => {
    const { name, surname, phone } = this.state;

    const { email } = this.props;

    if (this.state.dropinInstance) {
      this.state.dropinInstance.requestPaymentMethod(
        (requestPaymentMethodErr, payload) => {
          if (requestPaymentMethodErr) {
            this.setState({ error: requestPaymentMethodErr.message });
          } else {
            this.setState({ error: null, loading: true });
            firebase.auth.currentUser.getIdToken().then((token) => {
              subscribe(token, payload.nonce, name, surname, email, phone, plan)
                .then((result) => {
                  this.props.dispatch(activatePaypalUser(result.data));
                  return swal({
                    imageUrl: logo,
                    title:
                      '<div class="titleModal">Your subscription has been completed!</div>',
                    html: '<p class="contentModal"></p>',
                    showConfirmButton: true,
                    showCloseButton: false,
                    background: '#121C24',
                    allowOutsideClick: false
                  }).then((res) => {
                    firebase.auth.currentUser.getIdToken(true);
                    this.setState({ loading: false });
                    window.location.href = 'myprofile';
                  });
                })
                .catch(() => {
                  this.setState({
                    loading: false,
                    error: 'The payment failed'
                  });
                });
            });
          }
        }
      );
    }

    event.preventDefault();
  };

  validate(name, surname, email, phone) {
    // true means invalid, so our conditions got reversed
    return {
      name: name === null,
      surname: surname === null,
      email: email === null,
      phone: phone === null
    };
  }

  handleBlurAll = () => (evt) => {
    alert('hi');
    this.handleBlur('name');
    this.handleBlur('surname');
    this.handleBlur('email');
    this.handleBlur('phone');
    alert('bye');
  };

  showForm = (option, plan, event) => {
    this.setState({ isShowForm: option });

    let $this = this;
    if (option) {
      dropin.create(
        {
          authorization: $this.props.braintreeToken,
          container: '.dropin-container',
          paypal: { flow: 'vault' }
        },
        function(createErr, dinInstance) {
          $this.setState({ dropinInstance: dinInstance });
        }
      );
      const plans = this.props.plans;
      (plans || []).map((p) => {
        p.planName === plan
          ? this.setState({
              infoMessage: `You have selected a ${plan} for $${p.planPrice}`,
              typePlan: p.planId
            })
          : '';
      });
    }
    event.preventDefault();
  };

  render() {
    const { name, surname, email, phone } = this.state;

    const plans = this.props.plans;

    const errors = this.validate(
      this.state.name,
      this.state.surname,
      this.state.email,
      this.state.phone
    );
    const shouldMarkError = (field) => {
      const hasError = errors[field];
      const shouldShow = this.state.touched[field];
      return hasError ? shouldShow : false;
    };
    const isEnabled =
      name !== null && surname !== null && email !== null && phone !== null;

    return (
      <BlockUi tag="div" blocking={this.state.loading}>
        <div
          className="main-page"
          style={{ marginTop: 15, padding: 10, marginBottom: 40 }}
        >
          <form>
            {this.state.isShowForm ? (
              <div>
                <div
                  className="headerDivDesc"
                  style={{
                    textAlign: 'center',
                    fontSize: '18pt',
                    marginBottom: 10
                  }}
                >
                  {this.state.infoMessage}
                </div>
                <FormGroup controlId="name">
                  <FormControl
                    componentClass="input"
                    className={
                      shouldMarkError('name')
                        ? 'error styleFieldForm'
                        : 'styleFieldForm'
                    }
                    onBlur={this.handleBlur('name')}
                    placeholder="First name"
                    type="text"
                    onChange={(event) =>
                      this.setState(byPropKey('name', event.target.value))
                    }
                  />
                </FormGroup>
                <FormGroup controlId="surname">
                  <FormControl
                    componentClass="input"
                    className={
                      shouldMarkError('surname')
                        ? 'error styleFieldForm'
                        : 'styleFieldForm'
                    }
                    onBlur={this.handleBlur('surname')}
                    placeholder="Last name"
                    type="text"
                    onChange={(event) =>
                      this.setState(byPropKey('surname', event.target.value))
                    }
                  />
                </FormGroup>
                <FormGroup controlId="email">
                  <FormControl
                    componentClass="input"
                    className={
                      shouldMarkError('email')
                        ? 'error styleFieldForm'
                        : 'styleFieldForm'
                    }
                    onBlur={this.handleBlur('email')}
                    placeholder="Email"
                    type="email"
                    onChange={(event) =>
                      this.setState(byPropKey('email', event.target.value))
                    }
                  />
                </FormGroup>
                <FormGroup controlId="phone">
                  <FormControl
                    componentClass="input"
                    className={
                      shouldMarkError('phone')
                        ? 'error styleFieldForm'
                        : 'styleFieldForm'
                    }
                    onBlur={this.handleBlur('phone')}
                    placeholder="Phone number"
                    type="tel"
                    onChange={(event) =>
                      this.setState(byPropKey('phone', event.target.value))
                    }
                  />
                </FormGroup>
                <div className="dropin-container"></div>
              </div>
            ) : (
              ''
            )}
            {!this.state.isShowForm ? (
              <>
                <div style={{fontWeight: 100, fontSize: 16, marginLeft: 20}}>
                  Upgrade to a New Plan:
                </div>
                <div
                  onClick={this.handleBlurAll}
                  className="btn-group-subscribe row"
                  style={{ textAlign: 'center', marginTop: '15px' }}
                >
                  {(plans || []).map((plan) => (
                    <Overlay key={plan.planId} text={plan.description.includes("description") ? "" : plan.description}>
                      <div key={plan.planId} className="tile">
                        <Button
                          type="submit"
                          className="btn-subscribe btn-general"
                          onClick={(e) => this.showForm(true, plan.planName, e)}
                        >
                          {plan.planName}* <p>${plan.planPrice}</p>
                          <div style={{marginTop: 20}}>Select <i className="fa fa-angle-double-right" style={{color: 'lightgreen', fontSize: 20}}></i></div>
                        </Button>
                        <p className="text-btn-subscribe">
                          *You will be billed every {plan.billingFrequency}{' '}
                          {plan.billingFrequency > 1 ? 'months' : 'month'}.
                        </p>
                      </div>
                    </Overlay>
                  ))}
                </div>
              </>
            ) : (
                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                  <Button
                    type="button"
                    disabled={!isEnabled}
                    className="btn-general btn-paypal"
                    onClick={(e) => this.checkout(this.state.typePlan, e)}
                  >
                    Submit
                  </Button>
                  <Button
                    type="button"
                    className="btn-general btn-paypal"
                    onClick={(e) => this.showForm(false, '', e)}
                    style={{ backgroundColor: '#CBCBCC', border: 'none' }}
                  >
                    Cancel
                  </Button>
                </div>
            )}
          </form>
        </div>
      </BlockUi>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    braintreeToken: store.user.braintreeToken,
    plans: store.user.plans
  };
};

export default connect(mapStateToProps)(PaypalPage);
